//ultimo step della stampa
export interface IClinicalEvalAnswer {
    siteId: string;
    site: string; //quando e` il ventricolo sinistro si valorizza l'array subsection da stampare
    value: string;
    idx?: number;
}

/*oggetto intermedio per preparazione alla stampa
 * poi il site sara il kineticSite
 * il value di sopra sara ${segmentName}'primosepratore'${segmentValue} 'secondo separatore' NB i segmentName sono unici quindi non avrebbe senso gruppare
 * se inverso invece avremo ${segmentValue}:${concatenazione di tutti i nomi sotto quel valore}
 * */
export interface IKineticPrint {
    label: string;
    value: string;
    idx?: number;
}

export enum EKineticConfig {
    'NO_LV_KINETIC' = 'NO_LV_KINETIC',
    'INCLUDE_LV_KINETIC' = 'INCLUDE_LV_KINETIC',
    'ONLY_LV_KINETIC' = 'ONLY_LV_KINETIC', //escludi le morfologiche ovvero ClinicalEval (per come strutturato al momento andra a prendere le cinetiche normal
    //quale binding stampare della cinetica se selezionato implica inclusione della cinetica da stress
}

export type ClinicalEvalExporterParams = [
    mode: EKineticConfig,
    isHtml: boolean,
    siteInBold: boolean,
    siteSeparator: string,
    valueSeparator: string,
    leftKineticTitle: string,
    reversePrintKinetic: boolean,
    segmentLabelSeparator: string,
    segmentValueSeparator: string,
    segmentSeparator: string,
    target: string,
    idClinicalEvalSite?: string | null,
];
